import { render, staticRenderFns } from "./BuyPlan.vue?vue&type=template&id=9426c688&scoped=true"
import script from "./BuyPlan.vue?vue&type=script&lang=js"
export * from "./BuyPlan.vue?vue&type=script&lang=js"
import style0 from "./BuyPlan.vue?vue&type=style&index=0&id=9426c688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9426c688",
  null
  
)

export default component.exports